import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessTypeE } from '@generated/be';
import { AuthService } from '@shared/utils';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

/** Checks if the current user has the given roles */
export function hasAccess$(...accesses: AccessTypeE[]): Observable<boolean> {
  const authService = inject(AuthService);

  return authService.user$.pipe(
    map((user) => {
      const userAccesses = user?.accesses || [];
      return accesses.some((role) => userAccesses.includes(role));
    }),
    shareReplay(1)
  );
}

export function hasAccess(...accesses: AccessTypeE[]): boolean {
  const authService = inject(AuthService);

  const userAccesses = authService.getCurrentUser()?.accesses || [];

  return accesses.some((role) => userAccesses.includes(role));
}

// Obecná funkce pro vytvoření CanActivateFn na základě dané funkce pro ověření oprávnění
export function canActivateByAccess(...accesses: AccessTypeE[]): CanActivateFn {
  return () => {
    const router = inject(Router);

    return hasAccess$(...accesses).pipe(
      map((hasPermission) => {
        if (!hasPermission) {
          router.navigate(['/']); // Přesměrování na domovskou stránku, pokud uživatel nemá požadovanou roli
          return false;
        }
        return true;
      })
    );
  };
}

/*
 CanActivateFn, který umožňuje přístup pouze v interním prostředí.
 Slouží pro ochranu stránek, které by neměly být dostupné v zákaznickém prostředí.
*/
